import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class UserBankDetailsService {

    getEventRoute = '/api/userbankdetails/';

    constructor(private dataService: DataService) {
    };   

    save(result: any) {
        return this.dataService.post('/api/userbankdetails', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

   
}
